/**
 * Created by staffanrantzow on 14/06/16.
 */

class TaxkeyEntity {

  constructor (
    id,
    active,
    taxkeyName,
    taxkeyValue,
    taxAmount,
    payrollTax,
    fee,
    feeExpress,
    feeDiscount,
  ) {
    this.id = id;
    this.active = active;
    this.taxkeyName = taxkeyName;
    this.taxkeyValue = taxkeyValue;
    this.taxAmount = taxAmount;
    this.payrollTax = payrollTax;
    this.fee = fee;
    this.feeExpress = feeExpress;
    this.feeDiscount = feeDiscount;
  }

}

export default TaxkeyEntity;



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/taxkeys/taxkey-entity.js
 **/